

export default {
  data() {
    return {
     
      
    };
  },
  

  computed: {
    knownDocs(){
      return this.$store.getters.getKnownDocs
    },
    showAll(){
      return this.$store.getters.getPlayerAll 
   },
   locationInfo(){ 
    
    if(this.mapInfo && this.mapInfo.locations && this.knownDocs){
      let locs=[]
      let loc
     
        for(var l in this.mapInfo.locations ){
         
          if(this.knownDocs.includes(this.mapInfo.locations[l].id) || this.showAll){  
            loc=this.$store.getters.getLocation(this.mapInfo.locations[l].id)
          
            if(loc){
              locs.push(loc)
            }
          }
        }
        
        return locs
    }else{
      return null
    }

},

  },
  methods: {
   
    
  }
  
}